import React, { useCallback, useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import { NAV_LINKS } from '../../components/Layout/WorkspaceLayout/constants';
import NavContext from './NavContext';

const NavProvider = ({ children }) => {
  const location = useLocation();

  const activePage = useMemo(() => {
    const activeParent = NAV_LINKS.find(
      (link) => link.path && matchPath(location.pathname, link.path)
    );

    if (activeParent) return activeParent.label;

    const activeChild = NAV_LINKS.reduce((found, link) => {
      if (found) return found;

      return link.nestedLinks?.find((nestedLink) =>
        matchPath(location.pathname, nestedLink.path)
      );
    }, null);

    return activeChild?.label;
  }, [location.pathname]);

  const hasActiveNestedLink = useCallback(
    (parentLink) => {
      if (!parentLink.nestedLinks) return false;

      return parentLink.nestedLinks.some((nestedLink) =>
        matchPath(location.pathname, nestedLink.path)
      );
    },
    [location.pathname]
  );

  const contextValue = useMemo(
    () => ({ activePage, hasActiveNestedLink }),
    [activePage, hasActiveNestedLink]
  );

  return <NavContext.Provider value={contextValue}>{children}</NavContext.Provider>;
};

NavProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NavProvider;
